var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"context"},[_c('div',{staticClass:"title"},[_vm._v("ZADA CASH is your trusted")]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("financia partner")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("Zada Cash provides convenient credit services without high fees, simple application steps and fast approval. Zada ​​Cash is your trusted financial partner.")]),_vm._v(" "),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"btn_left"}),_vm._v(" "),_c('div',{staticClass:"btn_right"})])]),_vm._v(" "),_c('img',{attrs:{"src":require("@/assets/banner_icon.png")}})])
}]

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/banner.vue?vue&type=template&id=2d374eb2&scoped=true
// module id = null
// module chunks = 